interface ConditionalRendererProps {
    condition: boolean
    children: JSX.Element
}

const ConditionalRenderer = ({ condition, children }: ConditionalRendererProps) => (condition ? children : null)

export default ConditionalRenderer
